<form *ngIf="!this.loading" [formGroup]="editForm">
  <div class="form-group form-floating mb-3">
    <div class="form-floating mb-4" [appValidateState]="editForm.get('title')">
      <div class="inpt-title">{{ "name" | transloco }}</div>
      <input
        id="title"
        formControlName="title"
        type="text"
        class="inpt"
        placeholder="{{ 'name' | transloco }}"
        autocomplete="off"
      />
    </div>
    <div class="inpt-title mt-3">{{ "checklist" | transloco }}:</div>
    <div formArrayName="items">
      <button
        class="btn btn-orange shadow-sm"
        icon="pi pi-plus"
        (click)="addChecklistItem()"
      >
        {{ "add" | transloco }}
      </button>
      <div
        *ngFor="let chl of checkListItemFormArray.controls; let i = index"
        [formGroupName]="i"
        class="d-flex align-items-center gap-2 mb-2"
      >
        <input
          type="text"
          formControlName="title"
          class="form-control border rounded px-2"
          placeholder="{{ 'title' | transloco }}"
        />
        <button
          mat-icon-button
          class="text-danger"
          (click)="removeChecklistItem(i)"
        >
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
    <div class="d-flex gap-2 mt-4">
      <button 
      type="button" 
      class="btn btn-orange shadow-sm flex-grow-1"
      (click)="onSubmit()"
      [disabled]="editForm.invalid">
        {{ "save" | transloco }}
      </button>
    </div>
  </div>
</form>